import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { LoaderSkeleton, SingleLineText } from '@bloomays-lib/ui.shared';
import { TitlePart } from '@bloomays-lib/ui.shared';
import { IMission } from '@bloomays-lib/types.shared';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import BusinessIcon from '@mui/icons-material/Business';

type ListMissionChoiceProps = {
  loading: boolean;
  data?: IMission[];
};

const ListMissionChoice = ({ loading, data }: ListMissionChoiceProps) => {
  const navigate = useNavigate();

  return (
    <div>
      <TitlePart span="Choix de la mission" />
      <SingleLineText text="En cliquant sur la mission de ton choix, tu pourras ajouter un CRA" />
      <Container>
        {loading ? (
          <LoaderSkeleton width={300} height={100} />
        ) : (
          <StyledList>
            {data?.map((mission: IMission, i: number) => {
              return (
                <ListItem key={i} disablePadding>
                  <ListItemButton
                    id={`missionListButton${i}`}
                    onClick={() => {
                      navigate(`/mission/${mission?.recordId}`);
                    }}
                    sx={{
                      textDecoration: !mission.isActive ? 'line-through' : 'none',
                      opacity: !mission.isActive ? 0.6 : 1,
                      backgroundColor: 'grey.100',
                      marginBottom: '8px',
                      borderRadius: '8px',
                      '&:hover': {
                        backgroundColor: 'primary.light',
                        '& .MuiListItemText-primary': {
                          color: 'primary.contrastText',
                        },
                        '& .MuiListItemText-secondary': {
                          color: 'primary.contrastText',
                        },
                        '& .MuiSvgIcon-root': {
                          color: 'primary.contrastText',
                        },
                      },
                    }}
                  >
                    <ListItemIcon>
                      <BusinessIcon color="primary" />
                    </ListItemIcon>
                    <ListItemText primary={mission?.label} secondary={`Chez ${mission?.clientSociety?.name}`} />
                  </ListItemButton>
                </ListItem>
              );
            })}
          </StyledList>
        )}
      </Container>
    </div>
  ) as React.ReactNode;
};

export default ListMissionChoice;

const StyledList = styled(List)(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.palette.background.paper,
}));

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexFlow: 'column nowrap',
  backgroundColor: theme.palette.neutral.white,
  boxShadow: `2px 2px 20px ${theme.palette.neutral[10]}`,
  borderRadius: '10px',
  width: '60%',
  margin: '1em auto',
  padding: '1em',
}));
